export default __webpack_public_path__ + "static/media/lose.0f322e24.wav";